import { Anchor } from 'components/atoms';
import React from 'react';
import { useTranslation } from 'utils/hooks';

import css from './PremiumCta.module.scss';

type PremiumCtaProps = {
  formField: React.ReactNode;
};

const PremiumCta: React.FC<PremiumCtaProps> = ({ formField }) =>
{
  const { t, r } = useTranslation();

  return (
    <>
      <div className={css.cta}>

        <div className={css.plus} >{r('common:premium.plus')}</div>

        {formField}

        <p>{r('eintragungen:premium')}</p>

        <div className={css.row}>
          <Anchor href="/produkte">
            {t('common:premium.button')}
          </Anchor>
        </div>

      </div>
    </>
  );
};

export default PremiumCta;
